export const fetchPolicy = 'cache-and-network'
